import { useIntl } from 'react-intl';
import { StyledDiv, StyledFilterChips, StyledSpan } from './styled';
import { FilterChipsProps } from './types';

export const FilterChips = ({
  testId,
  handleChange,
  options,
  value,
  message
}: FilterChipsProps): React.JSX.Element => {
  const intl = useIntl();
  return (
    <StyledDiv>
      <StyledSpan>{intl.formatMessage(message)}</StyledSpan>
      <StyledFilterChips
        dataTestId={testId}
        onChange={handleChange}
        options={options}
        value={value}
      />
    </StyledDiv>
  );
};
